import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useAttendance } from '../../../hooks/Features/useAttendance'
import { itemsPerPage } from '../../../shared/data'
import CustomHeading from '../../CustomHeading'
import CustomPagination from '../../CustomPagination'
import Layout from '../../Layout'
import Loader from '../../Loader'
import CustomTable from '../../Table/CustomTable'
import CustomTableHeading from '../../Table/CustomTableHeading'
import CustomTableRow from '../../Table/CustomTableRow'
import styles from '../reports.module.css'
import { NoDataFound } from '../../NoDataFound'
import { useLead } from '../../../hooks/Features/useLeads'
import { formatNumber } from '../../../shared/constants'
import { SortIcon, FilterIcon } from '../../CustomComponents/CustomFilterIcon'

export default function ProductCategoryDetailedReportMTDReport() {
  const { loading, getLeadGenerationSummaryReport, lead } = useLead()
  const [page, setPage] = React.useState(1)
  const [date, setDate] = React.useState(new Date())

  useEffect(() => {
    setPage(1)
    getLeadGenerationSummaryReport({ date: date })
  }, [date])

  const noOfPages = Math.ceil(lead && lead.length / itemsPerPage)
  const handleChange = (event, value) => {
    setPage(value)
  }

  let tempArr = ['generated', 'quotes', 'won', 'lost']
  let tempTime = ['yesterday', 'MTD', 'QTD', 'YTD']

  let total = {}

  tempArr.forEach((tempValue) => {
    total[tempValue] = {}
    tempTime.forEach((time) => {
      total[tempValue][time] = {
        total: 0,
        value: 0,
      }
    })
  })

  const heading = [
    { label: 'Kbc', key: 'kbc' },
    { label: 'Tsm', key: 'tsm' },
    { label: 'Region', key: 'region' },
    { label: 'Zone', key: 'zone' },
    { label: 'State', key: 'state' },
    { label: 'District', key: 'district' },
    { label: 'city', key: 'city' },
    { label: 'Generated Yesterday', key: 'gy' },
    { label: 'Generated MTD', key: 'gm' },
    { label: 'Generated QTD', key: 'gq' },
    { label: 'Generated YTD', key: 'gyt' },
    { label: 'Quotation Sent Yesterday', key: 'qsy' },
    { label: 'Quotation Sent MTD', key: 'qsm' },
    { label: 'Quotation Sent QTD', key: 'qsq' },
    { label: 'Quotation Sent YTD', key: 'qsyt' },
    { label: 'Won Yesterday', key: 'wy' },
    { label: 'Won MTD', key: 'wm' },
    { label: 'Won QTD', key: 'wq' },
    { label: 'Won YTD', key: 'wyt' },
    { label: 'Lost Yesterday', key: 'ly' },
    { label: 'Lost MTD', key: 'lm' },
    { label: 'Lost QTD', key: 'lq' },
    { label: 'Lost YTD', key: 'lyt' },
  ]
  let tempLead = []
  lead &&
    lead.forEach((item) =>
      tempLead.push({
        kbc: item.rank6Name,
        tsm: item.rank5Name,
        region: item.region && item.region.name,
        zone: item.zone && item.zone.name,
        state: item.state && item.state.name,
        district: item.district && item.district.name,
        city: item.city && item.city.name,
        gy: item.generated.yesterday.qty,
        gm: item.generated.MTD.qty,
        gq: item.generated.QTD.qty,
        gyt: item.generated.YTD.qty,
        qsy: item.quotes.yesterday.qty,
        qsm: item.quotes.MTD.qty,
        qsq: item.quotes.QTD.qty,
        qsyt: item.quotes.YTD.qty,
        wy: item.won.yesterday.qty,
        wm: item.won.MTD.qty,
        wq: item.won.QTD.qty,
        wyt: item.won.YTD.qty,
        ly: item.lost.yesterday.qty,
        lm: item.lost.MTD.qty,
        lq: item.lost.QTD.qty,
        lyt: item.lost.YTD.qty,
      })
    )

  return (
    <Layout
      heading="Lead Generation Summary Report"
      none
      selectedDate={date}
      setSelectedDate={setDate}
      headers={heading}
      data={tempLead ? tempLead : []}
      tempHeaderData={[]}
      filename="lead_genearation_summary_report"
    >
      <CustomTable padding className={styles.table}>
        <CustomTableHeading
          heading={['kbc', 'tsm', 'REGION', 'ZONE', 'STATE', 'DISTRICT', 'CITY', 'GENERATED', 'QUOTATION SENT', 'WON', 'LOST']}
          columnSpan={{ GENERATED: 4, 'QUOTATION SENT': 4, WON: 4, LOST: 4 }}
        />
        <CustomTableRow className={styles.subHead}>
          <TableCell colSpan={7}></TableCell>
          {tempArr.map((val) => {
            return tempTime.map((item) => {
              return <TableCell style={{ borderLeft: item === 'yesterday' ? '1px solid black' : 'none' }}>{item}</TableCell>
            })
          })}
          <TableCell></TableCell>
        </CustomTableRow>
        <TableBody className={styles.tr}>
          {!loading &&
            lead.length > 0 &&
            lead.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item, index) => {
              tempArr.forEach((tempValue) => {
                tempTime.forEach((time) => {
                  total[tempValue][time].total += item[tempValue][time].qty
                  total[tempValue][time].value += item[tempValue][time].amount
                })
              })

              return (
                <CustomTableRow>
                  <TableCell>{item.rank6Name}</TableCell>
                  <TableCell>{item.rank5Name}</TableCell>
                  <TableCell>{item.region ? item.region.name : ''}</TableCell>
                  <TableCell>{item.zone ? item.zone.name : ''}</TableCell>
                  <TableCell>{item.state ? item.state.name : ''}</TableCell>
                  <TableCell>{item.district ? item.district.name : ''}</TableCell>
                  <TableCell>{item.city ? item.city.name : ''}</TableCell>
                  {tempArr.map((tempValue) => {
                    return tempTime.map((time) => {
                      return <TableCell style={{ borderLeft: time === 'yesterday' ? '1px solid black' : 'none' }}>{item[tempValue][time].qty}</TableCell>
                    })
                  })}
                </CustomTableRow>
              )
            })}
          {Boolean(
            tempLead.push({
              region: 'Total Numbers',
              zone: '',
              state: '',
              district: '',
              city: '',
              gy: total.generated.yesterday.total,
              gm: total.generated.MTD.total,
              gq: total.generated.QTD.total,
              gyt: total.generated.YTD.total,
              qsy: total.quotes.yesterday.total,
              qsm: total.quotes.MTD.total,
              qsq: total.quotes.QTD.total,
              qsyt: total.quotes.YTD.total,
              wy: total.won.yesterday.total,
              wm: total.won.MTD.total,
              wq: total.won.QTD.total,
              wyt: total.won.YTD.total,
              ly: total.lost.yesterday.total,
              lm: total.lost.MTD.total,
              lq: total.lost.QTD.total,
              lyt: total.lost.YTD.total,
            })
          )}
          {Boolean(
            tempLead.push({
              region: 'Bussiness Value',
              zone: '',
              state: '',
              district: '',
              city: '',
              gy: formatNumber(total.generated.yesterday.value),
              gm: formatNumber(total.generated.MTD.value),
              gq: formatNumber(total.generated.QTD.value),
              gyt: formatNumber(total.generated.YTD.value),
              qsy: formatNumber(total.quotes.yesterday.value),
              qsm: formatNumber(total.quotes.MTD.value),
              qsq: formatNumber(total.quotes.QTD.value),
              qsyt: formatNumber(total.quotes.YTD.value),
              wy: formatNumber(total.won.yesterday.value),
              wm: formatNumber(total.won.MTD.value),
              wq: formatNumber(total.won.QTD.value),
              wyt: formatNumber(total.won.YTD.value),
              ly: formatNumber(total.lost.yesterday.value),
              lm: formatNumber(total.lost.MTD.value),
              lq: formatNumber(total.lost.QTD.value),
              lyt: formatNumber(total.lost.YTD.value),
            })
          )}
          {!loading && lead.length > 0 && (
            <React.Fragment>
              <CustomTableRow>
                <TableCell>Total Numbers</TableCell>
                <TableCell colSpan={6}></TableCell>
                {tempArr.map((tempValue) => {
                  return tempTime.map((time) => {
                    return <TableCell style={{ borderLeft: time === 'yesterday' ? '1px solid black' : 'none' }}>{total[tempValue][time].total}</TableCell>
                  })
                })}
              </CustomTableRow>
              <CustomTableRow>
                <TableCell>Bussiness Value</TableCell>
                <TableCell colSpan={6}></TableCell>
                {tempArr.map((tempValue) => {
                  return tempTime.map((time) => {
                    return <TableCell style={{ borderLeft: time === 'yesterday' ? '1px solid black' : 'none' }}>{formatNumber(total[tempValue][time].value)}</TableCell>
                  })
                })}
              </CustomTableRow>
            </React.Fragment>
          )}
        </TableBody>
      </CustomTable>
      {loading && <Loader />}
      {!loading && lead.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}

      {!loading && lead.length === 0 && <NoDataFound />}
    </Layout>
  )
}
